<template>
  <v-form ref="form">
    <v-text-field v-model="terminology.name" label="Default Term" :rules="requiredRules" />
    <v-text-field v-model="terminology.value" label="Account Term" :rules="requiredRules" />
  </v-form>
</template>

<script>

export default {
  props: {
    terminology: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    requiredRules: [(v) => !!v || "This field is required"],
  }),
};
</script>

<style>
</style>